import VSelectReserveState from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectReserveState', VSelectReserveState),
};
